import { _ } from '../../vendor';
import FacilitySlots from '../collections/FacilitySlots';

import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

  urlRoot : '/facilities',

  initialize : function() {
    // Merge resources-data into actual collection
    this.set('facility_slots', new FacilitySlots(this.get('facility_slots')));

    if (typeof this.get('_joinData') != 'undefined') {
      delete this.attributes._joinData;
    }

    delete this.attributes.calendars;
  },

  _rbac : {
    "admin" : {
      "read" : true,
      "write" : true,
      "edit" : true,
      "remove" : true,
    },
    "user" : {
      "read" : false,
      "write" : false,
      "edit" : false,
      "remove" : false
    },
    "garage-staff" : {
      "read" : true,
      "write" : false,
      "edit" : false,
      "remove" : false
    },
    "manager" : {
      "read" : true,
      "write" : false,
      "edit" : false,
      "remove" : false
    },
    "booking-manager" : {
      "read" : false,
      "write" : false,
      "edit" : false,
      "remove" : false
    },
  },

    defaults : {
      "id" : "",
    }
});